import apiClient from '../shared/api/apiClient'
import { ENDPOINTS } from '../shared/api/endpoints'
import type {
  UnreadCountResponse,
  FetchNotificationsParams,
  PaginatedNotificationsResponse,
} from '../components/notificationsData'
export const initialNotifications: any[] = []

export const fetchUnreadCount = async (): Promise<UnreadCountResponse> => {
  const response = await apiClient.get<{ success?: boolean; data?: UnreadCountResponse; unreadCount?: number }>(
    ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT
  )
  const data = response.data?.data || response.data
  return {
    unreadCount: typeof data?.unreadCount === 'number' ? data.unreadCount : 0,
  }
}

export const fetchNotifications = async (
  params?: FetchNotificationsParams
): Promise<PaginatedNotificationsResponse> => {
  const response = await apiClient.get<any>(ENDPOINTS.NOTIFICATIONS.LIST, { params })
  const raw = response.data

  let items: any[] = []
  if (Array.isArray(raw)) {
    items = raw
  } else if (raw && Array.isArray(raw.data?.items)) {
    items = raw.data.items
  } else if (raw && Array.isArray(raw.data)) {
    items = raw.data
  } else if (raw && Array.isArray(raw.items)) {
    items = raw.items
  } else if (raw && Array.isArray(raw.notifications)) {
    items = raw.notifications
  } else if (raw && typeof raw === 'object' && Array.isArray(raw.result)) {
    items = raw.result
  }

  const meta = raw?.meta || {
    page: params?.page || 1,
    limit: params?.limit || 10,
    total: items.length,
    totalPages: 1,
    hasNextPage: false,
    hasPreviousPage: false,
  }

  return {
    items,
    meta,
  }
}

export const fetchNotificationsApi = async (params?: FetchNotificationsParams): Promise<any[]> => {
  try {
    const res = await fetchNotifications(params)
    if (res.items && res.items.length > 0) {
      return res.items
    }
    return initialNotifications
  } catch (err) {
    return initialNotifications
  }
}

export const markAllNotificationsRead = async (): Promise<void> => {
  await apiClient.patch(ENDPOINTS.NOTIFICATIONS.MARK_ALL_READ)
}

export const markNotificationRead = async (id: string): Promise<void> => {
  await apiClient.patch(ENDPOINTS.NOTIFICATIONS.MARK_READ(id))
}

export const markAllNotificationsReadApi = async (): Promise<{ success: boolean }> => {
  try {
    await markAllNotificationsRead()
    return { success: true }
  } catch {
    return { success: true }
  }
}

export const markNotificationReadApi = async (id: string): Promise<{ success: boolean }> => {
  try {
    await markNotificationRead(id)
    return { success: true }
  } catch {
    return { success: true }
  }
}
